
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../actions";
import Steps from "../../Components/Steps";
import FormNavigation from "../FormNavigation";
import { Checkbox } from "../../Components/Checkbox";
import Input from "../../Components/Input";
import { DECLARATION_NAME, DECLARATION_POSITION, DECLARATION_COMPANY_NAME, DECLARATION_PHONE, DECLARATION_EMAIL, DECLARATION_CONFIRM } from "../../Constants";
import ErrorMessage from "../../Components/ErrorMessage/index"
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useTradeWasteContext } from "../tradeWasteContext";
import PhoneNumber from "../../Components/PhoneNumber";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Step4 = () => {
  const [tradeWasteContext] = useTradeWasteContext();
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction });
  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
    defaultValues: state?.data
  });

  const onSubmit = (data: any) => {
    actions.updateAction(data);
    navigate("/step5");
  };
  const onBack = () => {
    navigate("/step3");
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <motion.div
      data-testid="step4"
      key="step4"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <Steps step={4} max={5} />
      <AnimatePresence>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} />)}
      </AnimatePresence>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <h2>Declaration by the applicant</h2>
          <ol>
            <li className="list-none">
              Submission of this application does not infer any right to discharge
              trade waste, nor does it infer that permission to discharge trade
              waste will be granted
            </li>
            <li className="list-none">
              Discharge of trade waste, plumbing and/or drainage works associated
              with the intended discharge of trade waste to the Corporation's sewer
              must not commence until the Water Corporation has accepted the Trade
              Waste Application to Discharge Commercial and Trade Waste to Sewer and
              a Permit has been issued by the Water Corporation to the applicant
            </li>
          </ol>
          <Input
            name={DECLARATION_NAME}
            id={DECLARATION_NAME}
            label="Name "
            type="text"
            register={register}
            registerOptions={{
              required: "Please enter your name"
            }}
            errorMessage={errors[DECLARATION_NAME]?.message as string}
            defaultValue={state[DECLARATION_NAME]}
          />
          <Input
            name={DECLARATION_POSITION}
            id={DECLARATION_POSITION}
            label="Position (optional)"
            type="text"
            register={register}
            defaultValue={state[DECLARATION_POSITION]}
          />
          <Input
            name={DECLARATION_COMPANY_NAME}
            id={DECLARATION_COMPANY_NAME}
            label="Company name (optional)"
            type="text"
            register={register}
            defaultValue={state[DECLARATION_COMPANY_NAME]}
          />
          <PhoneNumber
            name={DECLARATION_PHONE}
            id={DECLARATION_PHONE}
            register={register}
            errorMessage={errors[DECLARATION_PHONE]?.message as string}
            defaultValue={state[DECLARATION_PHONE]}
          />
          <Input
            name={DECLARATION_EMAIL}
            id={DECLARATION_EMAIL}
            label="Email "
            type="email"
            register={register}
            registerOptions={{
              required: "Please enter your email"
            }}
            errorMessage={errors[DECLARATION_EMAIL]?.message as string}
            defaultValue={state[DECLARATION_EMAIL]}
          />
          <p>
            Please read the{" "}
            <a href={tradeWasteContext?.termsConditionsUrl ?? ""}>
              terms and conditions
            </a>{" "}
            of this application and the{" "}
            <a href={tradeWasteContext?.legalUrl ?? ""}>
              Water Corporation’s Electronic Business Conditions of Use
            </a>
          </p>
          <Checkbox
            id={DECLARATION_CONFIRM}
            name={DECLARATION_CONFIRM}
            text="I confirm the information provided is true and correct and agree with the above Terms and Conditions "
            register={register}
            registerOptions={{
              required: "Please confirm"
            }}
          />
        </section>
        <FormNavigation isLast={false} handleBack={onBack} />
      </form >
    </motion.div>
  );
};

export default Step4;
